import { render, staticRenderFns } from "./CompetitionNoPageListComponent.vue?vue&type=template&id=cb53b15e&scoped=true"
import script from "./CompetitionNoPageListComponent.vue?vue&type=script&lang=js"
export * from "./CompetitionNoPageListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb53b15e",
  null
  
)

export default component.exports